import ar from './ar.json';
import en from './en.json';
import es from './es.json';

export default {
  ar,
  en,
  es 
};